// Module
var code = "<div class=\"gc-copyright\">Made with GuideChimp</div>";
// Exports
export default code;